import { Option } from "@inrev/core";
import { DateTime } from "luxon";
import { type FC } from "react";
import { calculateDelta } from "../calculateDelta";
import { FinancialPeriodBundle } from "../hooks/useFinancialsMetrics";
import { getRevenueFYEValue } from "../utils/financialMetricValues";
import { FinancialMetricCard } from "./FinancialMetricCard";

export type RevenueFYECardProps = {
	recentFYE?: FinancialPeriodBundle;
	previousFYE?: FinancialPeriodBundle;
};

export const RevenueFYECard: FC<RevenueFYECardProps> = ({ recentFYE, previousFYE }) => {
	const periodEndDate = recentFYE?.period?.periodEndDate;
	const recentYear = Option.map(periodEndDate, (date) => DateTime.fromISO(date).toFormat("yy"));
	const label = `Revenue (FYE${recentYear ? ` '${recentYear}` : ""})`;

	const recentRevenue = recentFYE?.incomeStatement?.view?.revenue.total.allowed;
	const previousRevenue = previousFYE?.incomeStatement?.view?.revenue.total.allowed;
	const value = getRevenueFYEValue(recentFYE);
	const delta = Option.doWith(
		{ recentRevenue, previousRevenue },
		({ recentRevenue, previousRevenue }) => calculateDelta(recentRevenue, previousRevenue),
	);

	return (
		<FinancialMetricCard testId="revenue-fye-card" label={label} value={value} delta={delta} />
	);
};
